export const UPDATE_TABLE_LAYOUT_CACHE = 'UPDATE_TABLE_LAYOUT_CACHE'

export const UPDATE_TABLE_LAYOUT_CACHE_STATUS =
    'UPDATE_TABLE_LAYOUT_CACHE_STATUS'
